import {io} from 'socket.io-client'

export const socketService = (auth?: {[key: string]: any}) => {
  const url = process.env.REACT_APP_FACE_DETECTIONS_WEB_SOCKET_BASE_URL || ''
  const socketConnection = io(url, {
    auth: auth || {},
    reconnection: false,
    transports: ['websocket'],
  })

  return socketConnection
}
